import { Divider } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Badge, Button, Stack, Row, Col, Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { usePDFStore } from '../Idb';
import bookempty from './../../../assets/bookempty.png'
import './SingleBook.css'

function SingleBook(props) {
    const { handleDownloadPDF, loadstatus } = usePDFStore();
    const { id } = useParams()
    const [book, setBook] = useState({})
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        
        const fetchBook = async () => {
            try {
                setLoading(true)
                const res = await axios.get('/singlebook/' + id, {
                    signal: controller.signal
                })
                if (isMounted) {
                    setBook(res.data)
                    setError(null)
                }
            } catch (err) {
                if (isMounted) {
                    if (err.name !== 'CanceledError') {
                        console.error('Kitobni yuklashda xatolik:', err)
                        setError('Kitobni yuklashda xatolik yuz berdi')
                    }
                }
            } finally {
                if (isMounted) {
                    setLoading(false)
                }
            }
        }
        
        fetchBook()
        
        return () => {
            isMounted = false
            controller.abort()
        }
    }, [id]);

    return (
        <Container>
            {error && (
                <div style={{
                    padding: '16px',
                    backgroundColor: '#fee2e2',
                    color: '#dc2626',
                    borderRadius: '8px',
                    marginBottom: '20px'
                }}>
                    {error}
                </div>
            )}
            {loading ? (
                <div style={{
                    height: '400px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div>Yuklanmoqda...</div>
                </div>
            ) : !book.img ? (
                <div style={{
                    height: '400px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div>Kitob topilmadi</div>
                </div>
            ) : (
            <Row className="g-4">
                <Col lg={4} md={5} sm={12}>
                    <div style={{
                        backgroundImage: 'url(' + bookempty + ')',
                        height: '500px',
                        padding: '10px',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        perspective: '1000px',
                    }}>
                        <img style={{
                            width: '200px',
                            height: '300px',
                            transform: 'rotateY(-25deg)',
                            marginTop: '15px',
                            marginRight: '30px'
                        }} src={book.img} alt={book.name} />
                    </div>
                </Col>
                <Col lg={8} md={7} sm={12} style={{
                    backgroundColor: '#ffffffba',
                    backdropFilter: 'blur(5px)',
                    borderRadius: '10px',
                    border: '1px solid #ffffff'
                }}>
                    <div className="badges-container">
                        <Stack
                            direction="horizontal"
                            gap={2}
                            className="flex-wrap"
                        >
                            <Badge pill bg="primary" className="badge-item">
                                Chiqarilgan yili: {book.year} y.
                            </Badge>
                            <Badge pill bg="success" className="badge-item">
                                Tili: {book.til}
                            </Badge>
                            <Badge pill bg="warning" text="dark" className="badge-item">
                                Chop etilgan joyi: {book.joy}
                            </Badge>
                            <Badge pill bg="dark" className="badge-item">
                                Muallif: {book.autor}
                            </Badge>
                            <Badge pill bg="light" text="dark" className="badge-item">
                                Nashriyot: {book.nashriyot}
                            </Badge>
                        </Stack>
                    </div>
                    <hr className="my-3" />
                    <h1>{book.name}</h1>
                    <hr className="my-3" />
                    <p><b>Izoh:</b> {book.izoh}</p>
                    <hr className="my-3" />
                    <Button
                        variant="primary"
                        disabled={loadstatus}
                        onClick={() => handleDownloadPDF(book.id, book.name, book.url, book.autor)}
                    >
                        {loadstatus ? 'Yuklanmoqda...' : 'Yuklab olish'}
                    </Button>
                </Col>
            </Row>
            )}
        </Container>
    );
}

export default SingleBook;